export default "__VITE_ASSET__6ASEIdf8__"